import { useState } from 'react';
import clsx from 'clsx';

interface AvatarProps {
  src?: string;
  name?: string;
  size?: 'sm' | 'md';
}

const initials = (name?: string) =>
  (name || '?')
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase() ?? '')
    .join('');

const Avatar = ({ src, name, size = 'md' }: AvatarProps) => {
  const [errored, setErrored] = useState(false);
  const dims = size === 'sm' ? 'h-8 w-8 text-xs' : 'h-10 w-10 text-sm';

  if (src && !errored) {
    return (
      <img
        src={src}
        alt={name || ''}
        onError={() => setErrored(true)}
        className={clsx('shrink-0 rounded-full object-cover', dims)}
      />
    );
  }

  return (
    <span
      className={clsx(
        'flex shrink-0 items-center justify-center rounded-full bg-brand-100 font-semibold text-brand-600 dark:bg-brand-500/20 dark:text-brand-300',
        dims
      )}
    >
      {initials(name)}
    </span>
  );
};

export default Avatar;
